//YYYY-MM-DD形式の文字列を変換
// Y: 年。4桁の数字。
// y: 年。2桁の数字。
// M: 月。2桁の数字。
// m: 月。1桁の数字。
// D: 日。2桁の数字。
// d: 日。1桁の数字。
// W: 曜日（日,月,火,水,木,金,土）

const weeks = ['日','月','火','水','木','金','土']

export default function dateformat(date, format) {
	if (!(date instanceof Date)) {
		if (/[1-9][0-9]+/.test(date)) {
			date = new Date(date)
		}
		else if (/^[1-9][0-9]{3}\-[0-1][0-9]\-[0-3][0-9]/.test(date)) {
			date = new Date(date.replace('/\-/g', '/'))
		}
		else {
			date = new Date(date)
		}
	}
	const Y = date.getFullYear()
	const y = Y.toString().slice(-2)
	const m = date.getMonth() + 1
	const M = ('0' + m).slice(-2)
	const d = date.getDate()
	const D = ('0' + d).slice(-2)
	const W = weeks[date.getDay()]
	return format
		.replace('Y', Y)
		.replace('y', y)
		.replace('M', M)
		.replace('m', m)
		.replace('D', D)
		.replace('d', d)
		.replace('W', W)
}